import { Button } from "antd";
import { ReactElement, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { LoginFormLayout } from "../../../layouts/LoginFormLayout/LoginFormLayout";
import { useAppDispatch } from "../../../store/reduxHooks";
import { SELECT_TYPE_POSITION } from "../../../store/selectors/authSliceLoginSelector";
import { TYPE_POSITION } from "../../../store/slice/authSliceLogin/authSliceLogin";
import { RegistrationClientForm } from "../RegistrationClientForm/RegistrationClientForm";
import { VerificationCSP } from "../VerificationCSP/VerificationCSP";

import classes from "./RegistrationClient.module.css";

export function RegistrationClient(): ReactElement {
  const userTypePosition = useSelector(SELECT_TYPE_POSITION);
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(TYPE_POSITION("DEFAULT"));
    };
  }, []);

  if (userTypePosition === "REGISTER_CSP") {
    return <VerificationCSP />;
  }

  return (
    <LoginFormLayout name="Регистрация">
      <RegistrationClientForm />
      <Link to={"/login"}>
        <Button size="large" className={classes.linkSignIn}>
          Уже есть аккаунт
        </Button>
      </Link>
    </LoginFormLayout>
  );
}
